module.exports = __webpack_public_path__ + "img/Weapon_121.806285ee.png";